(async function () {
  if ($("#interactive-map").length === 0) {
    return;
  }

  let { data } = await axios.post("helper/facilities-count-by-state");
  let facilities = data;

  $("#interactive-map > svg path:not([id*='path'])").on("mouseenter", function () {
    let abbr = $("#interactive-map tspan:contains(" + $(this).prop("id") + ")");
    $(this).css({ fill: "#ccdbd9" });
    if ($(this).parent()[0].tagName === "g") {
      $(this).siblings().css({ fill: "#ccdbd9" });
    }
  }).on("mouseout", function () {
    $(this).css({ fill: "#f9f9f9" });
    if ($(this).parent()[0].tagName === "g") {
      $(this).siblings().css({ fill: "#f9f9f9" });
    }
  }).on("click", function () {
    let abbr = $("#interactive-map tspan:contains(" + $(this).prop("id") + ")");
    let pointer = facilities.find(function (facility) {
      return facility.state.abbr === abbr.text();
    });
    if (pointer) {
      window.location.href = "/find-storage/" + pointer.state.slug;
    }
  });

  $("#interactive-map > svg tspan").on("mouseenter", function () {
    let state = $(this).html();
    $("#interactive-map > svg > path[id='" + state + "']").trigger("mouseenter");
    $("#interactive-map > svg > g[id='" + state + "'] path").trigger("mouseenter");
  }).on("mouseout", function () {
    let state = $(this).html();
    $("#interactive-map > svg > path[id='" + state + "']").trigger("mouseout");
    $("#interactive-map > svg > g[id='" + state + "'] path").trigger("mouseout");
  }).on("click", function () {
    let state = $(this).html();

    let res = $("#interactive-map > svg > g[id='" + state + "'] path")
      .first()
      .trigger("click");

    if (res.length == 0) {
      $("#interactive-map > svg > path[id='" + state + "']").trigger("click");
    }
  });
})();
